var map = {
	"./img_footer_facebook.png": "edba",
	"./img_footer_instagram.png": "5924",
	"./img_footer_kakaotalk.png": "63e0",
	"./img_footer_logo.png": "5fbf",
	"./img_footer_naverBlog.png": "e2d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a392";